import { REGISTER_URL, SIGN_IN_URL } from '../../constants';
import { useLanguage } from '../../i18n/LanguageContext';
import { asset } from '../../lib/asset';

function FinalSection() {
    const { t } = useLanguage();

    return (
        <section className="final">
            <div className="wrap">
                <div className="final-card rv">
                    <img className="mark" src={asset('apc-plus-icon.png')} alt="" width="84" height="84" />
                    <h2>
                        {t.finalTitle}{' '}
                        <span className="grad">{t.finalTitleAccent}</span>
                    </h2>
                    <p>{t.finalLead}</p>
                    <div className="hero-ctas" style={{ justifyContent: 'center' }}>
                        <a className="btn btn-primary" href={REGISTER_URL}>
                            {t.createFreeAccount}
                        </a>
                        <a className="btn btn-ghost" href={SIGN_IN_URL}>
                            {t.signIn}
                        </a>
                    </div>
                    <div className="stores">
                        <span className="store">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M16.4 12.6c0-2.4 2-3.6 2.1-3.7-1.1-1.7-2.9-1.9-3.5-1.9-1.5-.2-2.9.9-3.7.9-.8 0-1.9-.9-3.2-.8-1.6 0-3.1 1-4 2.4-1.7 3-.4 7.4 1.2 9.8.8 1.2 1.8 2.5 3 2.4 1.2 0 1.7-.8 3.1-.8 1.5 0 1.9.8 3.2.8 1.3 0 2.2-1.2 3-2.4.9-1.4 1.3-2.7 1.3-2.8-.1 0-2.5-1-2.5-3.9zM14 5.5c.7-.8 1.1-1.9 1-3-1 0-2.1.7-2.8 1.5-.6.7-1.2 1.8-1 2.9 1 .1 2.1-.6 2.8-1.4z" />
                            </svg>
                            <span>
                                <small>{t.storeAppleSmall}</small>
                                <b>App Store</b>
                            </span>
                        </span>
                        <span className="store">
                            <svg width="20" height="22" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M3.6 1.8c-.3.3-.4.8-.4 1.4v17.6c0 .6.2 1.1.4 1.4l10-10.2-10-10.2zm11.4 11.6l2.9 3-12 6.9c-.5.3-1 .3-1.4.1l10.5-10zm0-2.8L4.5.6c.4-.2.9-.2 1.4.1l12 6.9-2.9 3zm4.2 1.6c.7.4.7 1.3 0 1.7l-2.3 1.3-3.1-3.2 3.1-3.2 2.3 1.4z" />
                            </svg>
                            <span>
                                <small>{t.storeGoogleSmall}</small>
                                <b>Google Play</b>
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default FinalSection;
